import $ from 'jquery';
import {is_function} from '../../../Helpers/js';

const makeKeyboardTrigger = ($trigger, label) => {
  $trigger.attr({tabindex: 0, role: 'button', 'aria-label': label});
  $trigger.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $trigger.popup('toggle');
    }
    // Keep Escape from also closing the surrounding dialog
    if (e.key === 'Escape' && $trigger.popup('is visible')) {
      e.stopPropagation();
      $trigger.popup('hide');
    }
  });
};

/**
 * HTML-Attributes:
 *   data-role="tooltip"
 *   data-size="small|medium|large"
 *   data-link="closableLink" - when a link with [data-link="closableLink"] inside the popup is clicked, close a Popup
 * @param on - click|hover|focus|...
 */
$.fn.tooltip = function (on) {
  'use strict';

  this.each(function () {
    var $me = $(this);
    var html = $me.data('content') || $($me.data('contentSource')).html() || '';
    var label = [$me.data('title'), $('<div>').html(html).text()].filter(Boolean).join(': ');

    if ($me.data('title')) {
      var title = $('<div>').addClass('ui header').html($me.data('title')).get(0).outerHTML;
      html = title + html;
    }

    var onEvent = on || 'click';
    var popupParams = {
      on: onEvent,
      html: html,
      exclusive: true,
      observeChanges: false, // if true, tooltips don't work, when DOM is manipulated
      onCreate: function () {
        this.addClass('tooltip');
        if ($me.data('size')) {
          this.attr('data-size', $me.data('size'));
        }

        var $closableLink = $(this).find('[data-link="closableLink"]');
        if ($closableLink.length > 0) {
          $closableLink.on('click', () => {
            $me.popup('remove popup');
          });
        }
      },
    };

    var popupContext = $me.data('container');
    if (popupContext) {
      popupParams.context = $(popupContext);
      if (popupContext == '.ui.dimmer') {
        popupParams.className = {
          popup: 'ui popup left-txt',
        };
      }
    }

    var delay = $me.data('delay');
    if (delay) {
      popupParams.delay = {
        show: parseInt(delay, 10),
        hide: 0,
      };
    }

    if (onEvent == 'click') {
      $me.on('click', function (e) {
        e.stopPropagation();
      });
      if (!$me.is('a[href], button, input, select, textarea, [tabindex]')) {
        makeKeyboardTrigger($me, label);
      }
    }

    is_function($me.popup) && $me.popup(popupParams);
  });
};

$.initialize('[data-role="tooltip"]', function () {
  $(this).tooltip();
});
$.initialize('[data-role="hover-tooltip"]', function () {
  $(this).tooltip('hover');
});
$.initialize('[data-role="focus-tooltip"]', function () {
  $(this).tooltip('focus');
});
